import $ from "jquery";
import "./assets/jquery.mask.customize";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./assets/klass.VuwField";

/**
 * VuwTextField (extends VuwField)
 * @options
 * - {Boolean} required
 * - {Number} ltd
 * - {String} placeholder
 * - {String} unit
 * - {String} dataType: "email" | "url" | "tel" | "zip" ...
 */
vuwer.appendKlass("VuwTextField", {
	inpType: "text",
	inpClassList: ["inp", "inp-txt"],
	dataType: false,
	_applyDataTypes: (Klass("Console").device[0] === "sp") ? ["email", "url", "tel", "zip"] : [],
	
	_initialize: function _initialize(opt) {
		if( Klass("VuwTextField").parent._initialize.call(this, opt) ) {
			// [バリデーションの登録]
			// 必須
			this.addValidation("required", function(val) {
				return !this.required || !!val;
			}, "入力して下さい");
			
			// 文字数制限
			this.addValidation("ltd", function(val) {
				return !u_.isNumber(this.ltd) || String(val).length <= this.ltd;
			}, this.ltd ? String(this.ltd) + "文字以内にして下さい" : "");
			
			// dataTypeごとのバリデーション
			switch(this.dataType) {
				case "email": {
					this.addValidation("email", function(val) {
						const re = /^[A-Za-z0-9]{1}[\w+.-]*@{1}[\w.-]{1,}\.[A-Za-z0-9]{1,}$/;
						return !val || re.test(val);
					}, "メールアドレスの書式が正しくありません");
					break;
				}
				
				case "url": {
					this.addValidation("url", function(val) {
						return !val || (/^(https?:\/\/|mailto:|\.\.?\/)\w/).test(val);
					}, "URLの書式で入力して下さい");
					break;
				}
				
				case "tel":
				case "zip": {
					this.addValidation("hasFullChar", function(val) {
						return !val || !u_.hasFullChar(val);
					}, "半角数字またはハイフンで入力して下さい");
					break;
				}
			}
			
			// [入力部品のクラス]
			if( this.dataType && u_.isString(this.dataType) ) {
				this.inpClassList.push("inp-" + this.dataType);
			}
			
			// [required, ltd, disabled, readonly の動的な切り替え用]
			this.onChangeState(function(state) {
				if( state.hasOwnProperty("required") ) {
					this.required = !!state.required;
					delete state.required;
				}
				
				if( state.hasOwnProperty("ltd") ) {
					if( u_.isNumber(state.ltd) && state.ltd > 0) {
						this.ltd = state.ltd;
						this.errorMessages.ltd = String(this.ltd) + "文字以内にして下さい";
					}
					delete state.ltd;
				}
				
				if( state.hasOwnProperty("disabled") ) {
					!!this.$inp.length && this.$inp.prop("disabled", !!state.disabled);
					delete state.disabled;
				}
				
				if( state.hasOwnProperty("readonly") ) {
					!!this.$inp.length && this.$inp.prop("readonly", !!state.readonly);
					delete state.readonly;
				}
			});
			
			return this;
		} else {
			return false;
		}
	},
	
	getInpReady: function getInpReady($self) {
		// DOMツリーに登録される前のことも考慮して、$self.findで取得する
		this.$inp = $self.find("#" + ["inp", this.idStr].join("_"));
		if(this.$inp.length) {
			this.$inp
			.on("input.monitor", function(e) {
				var timer = $.data(this, "monitorTimer");
				!!timer && clearTimeout(timer);
				$.data( this, "monitorTimer", setTimeout( (function() {
					$(this).trigger("change", [false, "monitor"]);
				}).bind(this), 400) );
			})
			.on("change.setVal", function(e, isTrigger) {
				!isTrigger && $.data(this, "vuwField").setVal(this.value, true);
			});
			
			// **** attachPlugin ****
			// [mask]
			if($.fn.mask) {
				switch(this.dataType) {
					case "tel": {
						this.$inp.mask("00rrr0rrr0000", {
							translation: {
								r: {pattern: /[0-9-]/}
							}
						});
					} break;
					
					case "zip": {
						this.$inp.mask("000-0000");
					} break;
				}
			}
			
			$.data(this.$inp.get(0), "vuwField", this);
			
			this.clearVal();
		}
		return this;
	},
	
	setVal: function setVal(value, antiTriggerChange) {
		u_.isString(value) || (value = u_.isNumber(value) ? String(value) : "");
		Klass("VuwTextField").parent.setVal.call(this, value);
		
		if(this.$inp.length && !antiTriggerChange) {
			this.$inp.val(value).trigger("change", [true]);
		}
		return this;
	},
	
	_getCopiedInp: function _getCopiedInp() {
		var txt, clones = Klass("VuwTextField").parent._getCopiedInp.apply(this, arguments);
		if(clones.length) {
			switch(this.dataType) {
				case "url":
					txt = clones[0].text();
					clones[0] = $("<a/>").attr({
						href: txt,
						target: "_blank"
					}).append( clones[0].text( decodeURIComponent(txt) ) );
					break;
			}
			
			if( !!this.unit && u_.isString(this.unit) ) {
				clones.push( $("<span/>").addClass("unit").html( $.parseHTML(this.unit) ) );
			}
		}
		return clones;
	},
	
	_renderField: function _renderField() {
		var
			attr = {
				type: "text",
				name: this.paramKey,
				id: ["inp", this.idStr].join("_")
			},
			elms = [];
		
		// set dataType (only sp)
		if( this.dataType &&
				u_.isString(this.dataType) &&
				this._applyDataTypes.indexOf(this.dataType) >= 0 ) {
			attr.type = this.dataType;
			(attr.type === "zip") && (attr.type = "tel");
		}
		
		// set placeholder
		if( this.placeholder && u_.isString(this.placeholder) ) {
			attr.placeholder = this.placeholder;
		}
		
		elms.push( $("<input/>").addClass( this.inpClassList.join(" ") ).attr(attr) );
		if( !!this.unit && u_.isString(this.unit) ) {
			elms.push( $("<span/>").addClass("unit").html( $.parseHTML(this.unit) ) );
		}
		
		return $.fn.append.apply(
			$("<fieldset/>").addClass("vuw-field field-txt").attr({
				"id": ["field", this.idStr].join("_"),
				"data-name": this.paramKey
			}),
			elms
		);
	}
}, "VuwField");
